import immutableShallowEqual from '../../immutableShallowEqual';


export default function shouldComponentUpdate(nextProps, nextState) {
  return !immutableShallowEqual(this.props, nextProps) ||
         !immutableShallowEqual(this.state, nextState);
}



// WEBPACK FOOTER //
// ./src/components/component/shouldComponentUpdate.js